/* iZi PDP clips: laden bij zichtbaarheid, pauze buiten beeld, respect voor 'minder beweging', pauzeknop per sectie (8 sep 2026) */
(function(){
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused=false;
  function load(v){ if(!v.dataset.loaded){ if(v.dataset.src){v.src=v.dataset.src;} v.dataset.loaded='1'; } }
  function play(v){ if(paused||rm)return; load(v); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){play(e.target);} else { e.target.pause(); } });},{rootMargin:'250px 0px'}):null;
  function init(){
    document.querySelectorAll('video.izi-clip').forEach(function(v){
      if(v.dataset.iziInit)return; v.dataset.iziInit='1';
      if(rm){ v.removeAttribute('autoplay'); }
      v.addEventListener('click',function(){ if(v.paused){paused=false;play(v);} else {v.pause();} });
      if(io) io.observe(v); else play(v);
    });
    document.querySelectorAll('.izi-pdp[data-clips]').forEach(function(sec){
      if(sec.querySelector('.izi-clipknop'))return;
      var vids=sec.querySelectorAll('video.izi-clip'); if(!vids.length)return;
      var lbl=sec.getAttribute('data-clips-lbl')||'Clips pauzeren', lbl2=sec.getAttribute('data-clips-lbl2')||'Clips afspelen';
      var b=document.createElement('button'); b.type='button'; b.className='izi-clipknop'; b.setAttribute('aria-pressed',rm?'true':'false'); b.textContent=rm?lbl2:lbl;
      b.addEventListener('click',function(){
        var on=b.getAttribute('aria-pressed')==='true';
        if(on){ b.setAttribute('aria-pressed','false'); b.textContent=lbl; paused=false; vids.forEach(function(v){ load(v); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }); }
        else { b.setAttribute('aria-pressed','true'); b.textContent=lbl2; paused=true; vids.forEach(function(v){v.pause();}); }
      });
      var h=sec.querySelector('.izi-h2'); if(h&&h.parentNode){ h.parentNode.insertBefore(b,h.nextSibling); } else { sec.insertBefore(b,sec.firstChild); }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
})();

/* vouwknoppen (tabellen) toegankelijk: knop + aria-expanded */
(function(){
  function init(){
    document.querySelectorAll('[data-fold-btn]').forEach(function(b){
      if(b.dataset.iziInit)return; b.dataset.iziInit='1';
      b.addEventListener('click',function(){
        var open=b.getAttribute('aria-expanded')==='true'; var box=document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded',open?'false':'true'); if(box){ box.classList.toggle('is-open',!open); }
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
})();
